import { useSyncExternalStore } from "react";
import { flushSync } from "react-dom";

const listeners = new Set<() => void>();
let printing = false;
let stopListening: (() => void) | undefined;
const publish = () => flushSync(() => listeners.forEach((listener) => listener()));
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  if (listeners.size === 1) {
    const media = window.matchMedia?.("print");
    const before = () => {
      printing = true;
      publish();
    };
    const after = () => {
      printing = false;
      publish();
    };
    const change = () => {
      printing = media?.matches ?? false;
      publish();
    };
    printing = media?.matches ?? false;
    window.addEventListener("beforeprint", before);
    window.addEventListener("afterprint", after);
    media?.addEventListener("change", change);
    stopListening = () => {
      window.removeEventListener("beforeprint", before);
      window.removeEventListener("afterprint", after);
      media?.removeEventListener("change", change);
      printing = false;
    };
  }
  return () => {
    listeners.delete(listener);
    if (!listeners.size) {
      stopListening?.();
      stopListening = undefined;
    }
  };
};

/** Mount printable details synchronously without changing the user's expansion state. */
export const usePrintMode = () =>
  useSyncExternalStore(
    subscribe,
    () => printing,
    () => false,
  );
